// Meta Pixel utility - tracks PageView, ViewContent, AddToCart, InitiateCheckout
declare global {
  interface Window {
    fbq?: (...args: any[]) => void
    _fbq?: any
  }
}

const PIXEL_ID = '759566727183941'

let isInitialized = false

export function initPixel() {
  if (isInitialized || typeof window === 'undefined') return
  isInitialized = true

  const f: any = window
  if (f.fbq) {
    // Already loaded — just track
    f.fbq('init', PIXEL_ID)
    f.fbq('track', 'PageView')
    f.fbq('track', 'ViewContent', {
      content_name: 'Rituales de Pies Ancestrales',
      content_category: 'Wellness Digital Product',
    })
    return
  }

  const n: any = function () {
    // eslint-disable-next-line prefer-rest-params
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  f.fbq = n
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject script tag safely — use head/body as parent (sandbox-safe)
  try {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    const parent =
      document.head ||
      document.body ||
      document.getElementsByTagName('script')[0]?.parentNode
    if (parent) {
      parent.appendChild(script)
    }
  } catch (e) {
    // Silent fail — analytics shouldn't break the app
    console.warn('Meta Pixel script injection failed:', e)
  }

  // fbq is queued, so these will fire once the script loads
  f.fbq('init', PIXEL_ID)
  f.fbq('track', 'PageView')
  f.fbq('track', 'ViewContent', {
    content_name: 'Rituales de Pies Ancestrales',
    content_category: 'Wellness Digital Product',
  })
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window === 'undefined' || !window.fbq) return
  try {
    window.fbq('track', eventName, params)
  } catch (e) {
    console.warn('Meta Pixel track failed:', e)
  }
}

export function trackAddToCart(value: number, contentName: string) {
  trackEvent('AddToCart', {
    value,
    currency: 'ARS',
    content_name: contentName,
  })
}

export function trackInitiateCheckout(value: number, numItems: number) {
  trackEvent('InitiateCheckout', {
    value,
    currency: 'ARS',
    num_items: numItems,
  })
}
